import type { ClientContext } from '~/services/contextClient';
import type { FranchiseHubClientInterface } from './franchiseHubClient.types';
import CorporateFranchiseHubClient from './corporateFranchiseHubClient';

export default class FranchiseHubClientFactory {
    static createClient(context: ClientContext): FranchiseHubClientInterface {
        if (!context.orgUnitId && !context.groupId) {
            return new CorporateFranchiseHubClient(context.teamId);
        }

        throw new Error('The Franchise Hub dashboard is only available at corporate level');
    }
}
